import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageWSL4 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Manchester United Signings",
            author: "footballgirl",
            date: "January, 2026",
            image: "images/wsl/4a.jpg",
            content: `<p> <b>Man United Women: January 2026 Transfer Review</b></p>
<p>The January 2026 winter transfer window was an important period for Manchester United Women, as the club aimed to strengthen its squad for a challenging second half of the season — notably with UEFA Women’s Champions League knockout stages and a competitive Barclays Women’s Super League campaign ahead.</p>
<p>Strategic Reinforcements</p>
<p>Unlike some Premier League sides focusing solely on domestic competition, United were active in securing targeted recruits — bringing in players who could immediately impact the team’s offensive and tactical dynamics.</p>
<p>Ellen Wangerheim </p>
<p>Position: Forward


<p>Nationality: Swedish</p>


<p>Signed From: Hammarby IF</p>


<p>Contract: Through to June 2029</p>


<p>Date Completed: 16 January 2026</p>


<p>Manchester United Women officially announced the signing of Ellen Wangerheim, described by club officials as “one of Europe’s best young talents.” Her arrival added versatility and attacking potency to the squad — traits Marc Skinner’s side were keen to bolster ahead of crucial fixtures.
Wangerheim, 21, had scored regularly in Sweden’s top division prior to her move and immediately featured for United, making her debut in January.</p>

<p>Hanna Lundkvist </p>
<p>Position: Midfield / Left-Side Player</p>


<p>Nationality: Swedish</p>


<p>Signed From: Atlético Madrid</p>


<p>Joined: 1 January 2026</p>


<p>Sweden international Hanna Lundkvist made the move from Atlético Madrid to Old Trafford when the window opened. The 24-year-old featured early in January, coming off the bench in her first WSL appearance and adding depth on the left flank. </p>
<p>Lea Schüller</p>
<p>Position: Striker</p>


<p>Nationality: German</p>


<p>Signed From: Bayern Munich</p>


<p>Contract: Permanent transfer</p>


<p>United secured Lea Schüller from Bayern Munich in a significant piece of January business, reinforcing their goal-scoring options with a proven front-line presence. Schüller’s signing was one of the key highlights of the club’s winter market activity.</p>
<p>Why These Signings Matter
<p>Competitive Squad Depth: With a busy schedule featuring Champions League knockout ties and domestic league pressure, United needed reinforcements ready to plug into first-team roles.</p>

<p>European Ambitions: Signings like Wangerheim and Schüller raised Manchester United’s attacking profile, crucial for their European aspirations.</p>

<p>Youth & Potential: Lundkvist and Wangerheim offer long-term developmental upside while already possessing experience in major leagues.

</p> <p><b>Mandarin 中文版</b></p>

<p><b>曼联女足：2026年1月转会窗口回顾</b></p>

<p>2026年1月冬季转会窗口对于曼联女足而言是一个关键阶段。俱乐部希望在赛季下半程的激烈竞争中进一步增强阵容实力——尤其是在即将到来的欧洲女子冠军联赛淘汰赛阶段以及竞争激烈的巴克莱女子超级联赛赛程中。</p>

<p><b>战略性补强</b></p>

<p>与一些只专注于国内赛事的俱乐部不同，曼联在本次转会窗口中积极运作，精准引进能够立即提升球队进攻火力和战术灵活性的球员。</p>

<p><b>埃伦·万格海姆</b></p>

<p>位置：前锋<br>
国籍：瑞典<br>
转会来源：哈马比IF<br>
合同期限：至2029年6月<br>
完成日期：2026年1月16日</p>

<p>曼联女足正式宣布签下埃伦·万格海姆，俱乐部官员称她为“欧洲最优秀的年轻天才之一”。她的到来为球队锋线带来了更多多样性与攻击威胁——这是主教练希望在关键赛程前加强的方面。21岁的万格海姆在瑞典顶级联赛期间进球效率稳定，并在1月完成了代表曼联的首秀。</p>

<p><b>汉娜·伦德奎斯特</b></p>

<p>位置：中场 / 左路球员<br>
国籍：瑞典<br>
转会来源：马德里竞技<br>
加盟时间：2026年1月1日</p>

<p>瑞典国脚汉娜·伦德奎斯特在转会窗口开启时从马德里竞技转投老特拉福德。这位24岁的球员在1月初便迎来了自己的女子超级联赛首秀，并在左路为球队提供了重要的阵容深度。</p>

<p><b>莉娅·舒勒</b></p>

<p>位置：前锋<br>
国籍：德国<br>
转会来源：拜仁慕尼黑<br>
转会形式：永久转会</p>

<p>曼联成功从拜仁慕尼黑签下莉娅·舒勒，这是冬季转会市场上的一笔重磅引援。她作为一名经验丰富的锋线射手，为球队在进球能力方面提供了可靠保障，也是俱乐部冬窗运作中的亮点之一。</p>

<p><b>这些签约为何重要</b></p>

<p><b>阵容深度竞争力：</b> 随着欧冠淘汰赛与国内联赛双线作战压力加大，曼联需要能够迅速融入首发体系的补强球员。</p>

<p><b>欧洲赛场雄心：</b> 万格海姆与舒勒等进攻型球员的加盟，显著提升了球队锋线实力，对实现欧洲赛场目标至关重要。</p>

<p><b>年轻潜力与未来规划：</b> 伦德奎斯特和万格海姆不仅具备长期培养价值，同时已经拥有在高水平联赛征战的经验，为球队未来发展奠定基础。</p>
`
,
            tags: ["Man Utd", "Transfers", "WSL"],
            navIndices: { prev: 'wsl-3', next: 'wsl-5' }
        });
    }

    init() {
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to WSL
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'wslnews' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) { leagueLogo.src = '/images/league_wsl.png'; leagueLogo.alt = 'WSL'; }
    }
}